import Styled from 'styled-components';
import { isMobile } from '../../helpers';

export const TokenValidationErrorContainer = Styled.div`
  text-align: center;
  margin-top: ${isMobile ? 20 : 10}%;
`;

export const TokenValidationErrorTitle = Styled.div`
  padding: 0 50px;
`;

export const TokenValidationErrorIcon = Styled.div`
  margin-top: ${isMobile ? 25 : 50}px;
`;
